import StylishNewInput from '../../DesignSystems/New/StylishNewInput';
import React from 'react';
import { useFormContext } from 'react-hook-form';
import classNames from 'classnames';
import { RegisterOptions } from 'react-hook-form/dist/types/validator';

type FormNumericFieldProps = {
  title: string;
  fieldName: string;
  rules?: { [key: string]: { value: any; message: string } } | RegisterOptions;
  defaultValue?: string;
  variant?: 'full' | 'half' | 'none';
  min?: number;
  max?: number;
  step?: number;
  style?: object;
};

const FormNumericField: React.FC<FormNumericFieldProps> = ({
  title,
  fieldName,
  rules,
  defaultValue,
  variant = 'full',
  min,
  max,
  step,
  style,
}) => {
  const {
    register,
    formState: { errors },
  } = useFormContext();

  const required = typeof rules?.required === 'object' && rules.required.value;

  return (
    <div
      className={classNames('mt-2', {
        'col-6': variant === 'half',
        'col-12': variant === 'full',
      })}
    >
      <label className="form-label">
        {title}
        {required ? (
          <span aria-label="Required field" className="required">
            *
          </span>
        ) : null}
      </label>
      <StylishNewInput
        defaultValue={defaultValue}
        min={min}
        max={max}
        step={step}
        style={style}
        {...register(fieldName, rules)}
      />
      {errors[fieldName] ? (
        <div className="form-text form-error">
          {errors[fieldName].message as string}
        </div>
      ) : (
        <div className="form-text-none"></div>
      )}
    </div>
  );
};
export default FormNumericField;
